export default url => (
  fetch(url)
    .then(res => res.blob())
    .then(blob => URL.createObjectURL(blob))
)
